import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SidePanelContentDirective } from '@app/+authenticated/shared/app-side-panel/side-panel-content.directive';
import { SidePanelHeaderComponent } from '@app/+authenticated/shared/app-side-panel/side-panel-header.component';
import { SidePanelStateService } from '@app/+authenticated/shared/app-side-panel/side-panel-state.service';
import { SbSupportContentComponent } from '@app/+modals/sb-support/sb-support-content/sb-support-content.component';
import { ChecklistPanelComponent } from '@app/+side-panel/checklist-panel/checklist-panel.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TabComponent, TabGroupComponent } from '@sb/ui/tabs';

import { LearnTabComponent } from './learn-tab/learn-tab.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'support-panel',
  imports: [
    SidePanelHeaderComponent,
    SbSupportContentComponent,
    SidePanelContentDirective,
    TranslatePipe,
    TabGroupComponent,
    TabComponent,
    LearnTabComponent,
  ],
  templateUrl: './support-panel.component.html',
  styleUrls: ['./support-panel.component.scss'],
})
export class SupportPanelComponent {
  #panelState = inject(SidePanelStateService);

  openChecklist() {
    this.#panelState.setActive('checklist', ChecklistPanelComponent);
  }
}
